import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { colors, typo } from '../../theme/tokens';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
}

export default function SectionHeader({
  title,
  subtitle,
  icon,
  action,
}: SectionHeaderProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        mb: 2.5,
        gap: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        {icon && (
          <Box sx={{ color: colors.textPrimary, display: 'flex', fontSize: 20 }}>
            {icon}
          </Box>
        )}
        <Box>
          <Typography sx={typo.sectionTitle}>{title}</Typography>
          {subtitle && (
            <Typography sx={{ ...typo.smallText, mt: 0.25 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
      </Box>
      {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
    </Box>
  );
}
